import MetaMask from '../meta-mask.js';

class ExodusEvm extends MetaMask {
    constructor() {
        super(...arguments);
        this.name = 'ExodusEvm';
        this.canConnectViaQrCode = false;
    }
}

export { ExodusEvm as default };
